import { defineComponent, h, inject, provide, type InjectionKey } from "vue";
import TabContent from "./TabContent.vue";
import Tabs from "./Tabs.vue";
import TabsList from "./TabsList.vue";
import TabTrigger from "./TabTrigger.vue";

type TabInternalApi = {
	headerIdx: number;
	panelIdx: number;
};

const TabApiSymbol: InjectionKey<TabInternalApi> = Symbol();

/**
 * @deprecated Use Tabs instead
 */
export const SoftTabs = defineComponent({
	name: "SoftTabs",
	setup(_, { slots, attrs }) {
		provide(TabApiSymbol, {
			headerIdx: 0,
			panelIdx: 0,
		});

		return () => h(Tabs, { ...attrs, defaultValue: 1 }, () => slots.default?.());
	},
});

/**
 * @deprecated Use TabsList instead
 */
export const SoftTabHeaders = defineComponent({
	name: "SoftTabList",
	setup(_, { slots, attrs }) {
		return () => h(TabsList, attrs, () => slots.default?.());
	},
});

/**
 * @deprecated Use TabTrigger instead
 */
export const SoftTabHeader = defineComponent({
	name: "SoftTab",
	setup(_, { slots, attrs }) {
		const api = inject(TabApiSymbol);
		if (api == null) {
			throw new Error("SoftTabHeader must be used inside SoftTabs");
		}

		const id = ++api.headerIdx;

		return () => h(TabTrigger, { value: id, ...attrs }, () => slots.default?.());
	},
});

/**
 * @deprecated Use nothing instead
 */
export const SoftTabPanels = defineComponent({
	name: "SoftTabePanels",
	setup(_, { slots }) {
		return () => slots.default?.();
	},
});

/**
 * @deprecated Use TabContent instead
 */
export const SoftTabPanel = defineComponent({
	name: "SoftTabPanel",
	setup(_, { slots, attrs }) {
		const api = inject(TabApiSymbol);
		if (api == null) {
			throw new Error("SoftTabPanel must be used inside SoftTabs");
		}

		const id = ++api.panelIdx;

		return () => h(TabContent, { value: id, ...attrs }, () => slots.default?.());
	},
});
